import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "d-flex w-100 justify-content-end mb-4 pr-6" }
const _hoisted_2 = {
  key: 0,
  class: "d-flex justify-content-end mx-2"
}
const _hoisted_3 = { style: {"color":"red"} }

import MovePageBtn from '@/components/AccountParts/MovePageBtn.vue';
import CopyButton from "@/components/Common/CopyButton.vue";
import { ref, computed } from 'vue';
import i18n from '@/lang/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'InfoModalBtnArea',
  props: {
    copyText: { default: '' },
    modelValue: { type: Boolean, default: true },
    accountId: { default: null },
    isLoading: { type: Boolean, default: false },
    isDriverMode: { type: Boolean, default: false },
    roleAssignAuthority: { type: Boolean },
    update: {},
    changeModalStatus: {}
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;
const props = __props;

const isCopied = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  }
})

const isClickedMovePageBtn = ref(false as boolean)

const closeButtonClass = computed(() => {
  return isCopied.value ? 'close-btn' : 'exec-btn'
})

const isDisplayNotAuthorizedMessage = computed(() => {
  return !props.accountId && isClickedMovePageBtn.value && !props.roleAssignAuthority
})

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (props.isDriverMode)
        ? (_openBlock(), _createBlock(CopyButton, {
            key: 0,
            copyText: __props.copyText,
            modelValue: isCopied.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isCopied).value = $event))
          }, null, 8, ["copyText", "modelValue"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", null, [
        (props.isDriverMode && props.accountId)
          ? (_openBlock(), _createBlock(_component_v_btn, {
              key: 0,
              class: "close-btn ml-2 exec-btn",
              loading: props.isLoading,
              disabled: !isCopied.value,
              style: _normalizeStyle({
          backgroundColor : isCopied.value ? '' : '#B3B8BB'
        }),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (props.update && props.update(false)))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.common.button.conservation')), 1)
              ]),
              _: 1
            }, 8, ["loading", "disabled", "style"]))
          : (_openBlock(), _createBlock(MovePageBtn, {
              key: 1,
              routeName: "RoleAssaignment",
              title: _unref(i18n).global.t('pages.accounts.moveRoleAssignDisplayBtn'),
              class: "exec-btn ml-2",
              color: isCopied.value ? '#1976D2' : '#B3B8BB',
              style: {
          color: 'white'
        },
              disabled: !isCopied.value || isClickedMovePageBtn.value,
              modelValue: isClickedMovePageBtn.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((isClickedMovePageBtn).value = $event)),
              isMovable: props.roleAssignAuthority
            }, null, 8, ["title", "color", "disabled", "modelValue", "isMovable"]))
      ]),
      _createElementVNode("div", null, [
        (!props.accountId)
          ? (_openBlock(), _createBlock(MovePageBtn, {
              key: 0,
              routeName: "Accounts",
              title: _unref(i18n).global.t('pages.common.button.close'),
              class: _normalizeClass(`${closeButtonClass.value} ml-2`),
              color: isCopied.value ? '' : '#B3B8BB',
              style: {
          color: '#000000DE',
        },
              disabled: !isCopied.value
            }, null, 8, ["title", "class", "color", "disabled"]))
          : (_openBlock(), _createBlock(_component_v_btn, {
              key: 1,
              class: "close-btn ml-2",
              disabled: props.isLoading,
              style: _normalizeStyle({
          backgroundColor : props.isLoading ? '#B3B8BB' : ''
        }),
              onClick: _cache[3] || (_cache[3] = ($event: any) => (props.changeModalStatus && props.changeModalStatus(false)))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.common.button.close')), 1)
              ]),
              _: 1
            }, 8, ["disabled", "style"]))
      ])
    ]),
    (isDisplayNotAuthorizedMessage.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(i18n).global.t('pages.accounts.notAuthorizedMessage')), 1)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})